/** @format */

import React, { useState, useEffect, useCallback, useRef } from 'react'
import { useParams } from 'react-router-dom'

import moment from 'moment'

import { Spin, Row, Col } from 'antd'

import AvailableActions from './components/AvailableActions'
import UserInfoOrders from './components/UserInfoOrders'
import PharmacyInfo from './components/PharmacyInfo'
import OrderInfo from './components/OrderInfo'
import ModalRecipe from './components/ModalRecipe'
import Products from './components/Products'

import {
	serviceGetQuotation,
	serviceProcessNewStatus,
	serviceQuotationDigitalUpdateStatus,
} from './services'

import './style.css'

export default function QuotationDetail(props) {
	let { pharmacy, _id, rut, short_code } = useParams(props)
	const mounted = useRef(false)
	const [loading, setLoading] = useState(true)
	const [quotation, setQuotation] = useState({})
	const [digitalModal, setDigitalModal] = useState({
		confirm: false,
		rejected: false,
	})

	const handleGetQuotationDetail = useCallback(async () => {
		let response = await serviceGetQuotation({ _id, pharmacy, rut, short_code })
		if (!mounted.current) return
		setQuotation(response)
		setLoading(false)
	}, [_id, pharmacy, rut, short_code])

	useEffect(() => {
		mounted.current = true
		handleGetQuotationDetail()
		return () => (mounted.current = false)
	}, [handleGetQuotationDetail])

	const handleAproveOrReject = async (item) => {
		if (quotation.quotation.quotation_type === 'contract') {
			item = {
				...item,
				scheduleSelected: moment.unix(quotation.created_at).format(),
				price: quotation.quotation_pharmacy.product_info.price_per_quantity,
				quantity: quotation.quotation_pharmacy.quantity,
			}
		}
		let response = await serviceProcessNewStatus({
			_id,
			quotationType: quotation.quotation.quotation_type,
			...item,
		})
		if (response) await handleGetQuotationDetail()
	}

	const handleAproveOrRejectDigital = async (item, newStatus) => {
		let changedStructure = []
		if (newStatus === 'completed') {
			item.map((group) =>
				group.products.map((groupProd) => {
					return (changedStructure = [
						...changedStructure,
						{
							id_pharol: groupProd.id_pharol.toString(),
							quantity: groupProd.quantity,
							name_group: group.name,
						},
					])
				})
			)
		}
		setDigitalModal((pvSt) => ({ ...pvSt, confirm: false }))
		await serviceQuotationDigitalUpdateStatus({
			item_products: changedStructure,
			rut,
			short_code,
			newStatus,
			reason: item,
		})
		handleGetQuotationDetail()
	}

	if (loading) {
		return (
			<div className='ph-amp-spinner-container'>
				<Spin size='large' />
			</div>
		)
	}

	return (
		<div>
			{(quotation.status.status < 300 || quotation.status === 'requested') && (
				<AvailableActions
					id={_id}
					pharmacy={pharmacy}
					quotationType={quotation.quotation?.quotation_type || quotation.quotation_type}
					digitalModal={digitalModal}
					setDigitalModal={setDigitalModal}
					status={quotation.status.status || quotation.status}
					handleAproveOrReject={handleAproveOrReject}
					handleAproveOrRejectDigital={handleAproveOrRejectDigital}
				/>
			)}
			<Row>
				<Col lg={16}>
					<UserInfoOrders userInfo={quotation.quotation?.user_info || quotation.user_info} />
				</Col>
				<Col lg={8}>
					<OrderInfo
						id={quotation._id}
						status={quotation.status}
						code={quotation.quotation?.short_code || quotation.short_code}
					/>
				</Col>
			</Row>
			<Row className='ph-tracking-recipe-objected-pharmacy-recipe-global-container'>
				<Col lg={18}>
					{!!quotation.quotation_pharmacy && (
						<PharmacyInfo
							pharmacyInfo={quotation.quotation_pharmacy}
							comment={quotation.quotation.comment}
							status={quotation.status}
						/>
					)}
				</Col>
				<Col lg={6} className='ph-tracking-recipe-objected-img-global-container'>
					<h1 className='ph-tracking-recipe-objected-title-recipe'>Receta:</h1>
					{(quotation.quotation?.recipe_url || quotation.recipe_url) && (
						<ModalRecipe url={quotation.quotation?.recipe_url || quotation.recipe_url} />
					)}
				</Col>
			</Row>
			{!!quotation.quotation_pharmacy && (
				<Products
					status={quotation.status}
					products={[quotation.quotation_pharmacy.product_info]}
				/>
			)}
		</div>
	)
}
